module.exports = __webpack_public_path__ + "static/noticias-09--161ba39588a6b71b78c4762cf1c3cf39.png";